import {
  Card,
  Tabs,
} from 'antd';
import { BarChartOutlined, AuditOutlined, DashboardOutlined } from '@ant-design/icons';
import {
  ProductionStats,
  AuditsStats,
} from '../../components/dashboard';
import { usePageTitle } from '../../hooks';
import { PageHeader } from '../../components/common/PageHeader';
import './home.css';

export const Home = () => {
  usePageTitle('Inicio');

  return (
    <div className="home-page" style={{ padding: '24px' }}>
      <Card style={{ marginBottom: 24 }}>
        <PageHeader
          icon={<DashboardOutlined />}
          accent="#1677FF"
          title="Inicio"
          subtitle="Visualización de métricas y estadísticas"
          bottomGap={0}
        />
      </Card>

      {/* Tabs */}
      <Tabs
        defaultActiveKey="production"
        size="large"
        items={[
          {
            key: 'production',
            label: (
              <span>
                <BarChartOutlined />
                Producción Estimada
              </span>
            ),
            children: <ProductionStats />,
          },
          {
            key: 'audits',
            label: (
              <span>
                <AuditOutlined />
                Estadísticas de Auditorías
              </span>
            ),
            children: <AuditsStats />,
          },
        ]}
      />
    </div>
  );
};
